import { Routes, Route, Navigate } from "react-router-dom";
import { Suspense, lazy } from "react";
import { ProtectedRoute } from "./components/ProtectedRoute";
import Index from "./pages/Index";

// Lazy load routes that aren't needed for initial page load
const RestaurantDetail = lazy(() => import("./pages/RestaurantDetail"));
const Auth = lazy(() => import("./pages/Auth"));
const Admin = lazy(() => import("./pages/Admin"));
const RestaurantOwnerDashboard = lazy(() => import("./pages/RestaurantOwnerDashboard"));
const Neighborhoods = lazy(() => import("./pages/Neighborhoods"));
const NeighborhoodDetail = lazy(() => import("./pages/NeighborhoodDetail"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const BlogManagement = lazy(() => import("./pages/BlogManagement"));
const ResetPassword = lazy(() => import("./pages/ResetPassword"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const Terms = lazy(() => import("./pages/Terms"));
const Contact = lazy(() => import("./pages/Contact"));
const About = lazy(() => import("./pages/About"));
const NotFound = lazy(() => import("./pages/NotFound"));
const OAuthConsent = lazy(() => import("./pages/OAuthConsent"));

// Loading component for Suspense fallback
const PageLoader = () => (
  <div className="min-h-screen bg-accent flex items-center justify-center">
    <div className="animate-pulse text-muted-foreground">Loading...</div>
  </div>
);

export const AppRoutes = () => (
  <Suspense fallback={<PageLoader />}>
    <Routes>
      <Route path="/auth" element={<Auth />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/.lovable/oauth/consent" element={<OAuthConsent />} />
      <Route path="/" element={<Index />} />
      <Route path="/neighborhoods" element={<Neighborhoods />} />
      <Route path="/neighborhood/:name" element={<NeighborhoodDetail />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/about" element={<About />} />
      <Route 
        path="/admin" 
        element={
          <ProtectedRoute adminOnly>
            <Admin />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/admin/blog" 
        element={
          <ProtectedRoute adminOnly>
            <BlogManagement />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute>
            <RestaurantOwnerDashboard />
          </ProtectedRoute>
        } 
      />
      <Route path="/restaurant/:id" element={<RestaurantDetail />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </Suspense>
);

// Eager-loaded version for SSR (React.lazy doesn't work in SSR)
export const AppRoutesSSR = () => {
  // These will be dynamically imported in the SSR entry point
  // This component is not used directly - see entry-server.tsx
  return null;
};
